import { ModalOptions, Size } from 'components/modal';

export class BrandProfileModalData {
    options: ModalOptions = { size: Size.Dynamic };
    brandId = '';
    show = false;
}

export enum RetailerMainNavigationItem {
    Home = 'home',
    Brands = 'brands',
    Insights = 'insights',
    OrderHistory = 'order-history'
}
